import React, { FC, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CoreModal, CoreModalProps } from '../../../_core/components/_ui/core-modal';
import { CoreButton } from '../../../_core/components/_ui/core-button';
import { EngagementSurveyDto, FamilyWithSurveyDto, SurveyAnswerDto } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { buttonModalWindowStyles, mainTitleModalWindowStyles } from '../../../_core/styles';
import { mergeSx } from 'merge-sx';
import { useAttachFamilyToSurveyAnswerMutation } from '../../../../store/api/survey.api';
import { useSnackbar } from 'notistack';
import { FamilyAttachTable } from '../family-attach-table/family-attach-table.component';

export type AttachFamilyModalProps = CoreModalProps & {
	surveyAnswer: SurveyAnswerDto;
	closeModal(): void;
	familiesWithSurveyList: FamilyWithSurveyDto[];
};

export const AttachFamilyModal: FC<AttachFamilyModalProps> = (props) => {
	const [t] = useTranslation();
	const { surveyAnswer, closeModal, familiesWithSurveyList, ...modalProps } = props;
	const [selectedRow, setSelectedRow] = useState<string | null>(null);
	const { enqueueSnackbar } = useSnackbar();
	const showToast = (message: string, variant: 'error' | 'default' | 'success' | 'warning' | 'info' | undefined) => {
		enqueueSnackbar(message, {
			variant,
		});
	};

	const [attachFamilyToSurveyAnswer, { isLoading }] = useAttachFamilyToSurveyAnswerMutation();
	const handleOnAttachFamily = async () => {
		try {
			if (selectedRow) {
				await attachFamilyToSurveyAnswer({ surveyAnswerId: surveyAnswer._id, familyId: selectedRow }).unwrap();
				showToast('Successfully attached family', 'success');
				closeModal();
			} else {
				showToast('Choose family for attaching', 'error');
			}
		} catch (error) {
			showToast('Something goes wrong', 'error');
			console.log(error);
		}
	};

	return (
		<CoreModal {...modalProps} bodySx={{ pt: 0 }} paperSx={{ width: '100%' }}>
			<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
				<Typography variant="h5" sx={mergeSx(mainTitleModalWindowStyles)}>
					Assign answer to the specific Family:
				</Typography>
				<Box sx={{ display: 'flex', width: '100%' }}>
					<FamilyAttachTable
						data={familiesWithSurveyList}
						loading={false}
						onRowSelect={setSelectedRow}
						selectedRowId={selectedRow}
					/>
				</Box>

				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						gap: 3,
						mt: 5,
					}}
				>
					<CoreButton
						onClick={closeModal}
						variant="secondary"
						sx={mergeSx(buttonModalWindowStyles, { minWidth: '120px', height: '48px' })}
					>
						Cancel
					</CoreButton>
					<CoreButton
						onClick={handleOnAttachFamily}
						variant="info-light"
						contraModeStyleButton
						sx={mergeSx(buttonModalWindowStyles, { minWidth: '120px', height: '48px' })}
						disabled={!selectedRow || isLoading}
						loading={isLoading}
					>
						Save
						{/* { t('families.forms.buttons.save')} */}
					</CoreButton>
				</Box>
			</Box>
		</CoreModal>
	);
};
